import { Action } from '@ngrx/store';


export const SET_CURRENT_MODULE = '[Module] Set Current Module';

export class SetCurrentModuleAction implements Action{
	readonly type = SET_CURRENT_MODULE;
	constructor(public module:string){

	}
}

export type acciones = SetCurrentModuleAction;